module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-base-3.a0edaa70.png";